// @ts-strict-ignore
import { NodeType } from '../model/client-model/properties/node-type';
import { NodeProperties } from '../model/client-model/properties/node.properties';
import { TransitionTargetStatus } from '../model/enums/transition-target-status';

export function isNodeAchievable<
  T extends {
    nodeProperties?: NodeProperties;
  }
>(node: T): boolean {
  const isTarget = node.nodeProperties && node.nodeProperties.type === NodeType.Target ? true : false;
  const achievable =
    isTarget && node.nodeProperties.status !== undefined
      ? node.nodeProperties.status !== TransitionTargetStatus.ACHIEVABLE_LATER &&
        node.nodeProperties.status !== TransitionTargetStatus.NOT_ACHIEVABLE
      : !node.nodeProperties?.achievableLater && !node.nodeProperties?.notAchievable;

  return achievable;
}
